import { AfterViewInit, Component, ElementRef, ViewChild, OnInit } from '@angular/core';
import * as pbi from 'powerbi-client';

@Component({
    selector: 'app-view-reports',
    templateUrl: './view-reports.component.html',
    styleUrl: './view-reports.component.scss',
    standalone: false
})
export class ViewReportsComponent implements OnInit, AfterViewInit {
  @ViewChild('embeddedReport') embeddedReport: ElementRef;
  reportData: any;
  constructor() {}

  ngOnInit(): void {
    if (sessionStorage.getItem('reportData')) {
      this.reportData = JSON.parse(sessionStorage.getItem('reportData'));
    }
  }

  ngAfterViewInit() {
    this.showReport();
  }

  showReport() {
    const embedUrl = decodeURIComponent(this.reportData?.url);
    const accessToken = this.reportData?.accessToken;
    const reportId = this.reportData?.externalReportId;
    let config = {
      type: 'report',
      tokenType: pbi.models.TokenType.Embed,
      accessToken: accessToken,
      embedUrl: embedUrl,
      id: reportId,
      filters: [],
      settings: {
        filterPaneEnabled: true,
        navContentPaneEnabled: true,
      },
    };

    let powerbi = new pbi.service.Service(
      pbi.factories.hpmFactory,
      pbi.factories.wpmpFactory,
      pbi.factories.routerFactory
    );
    let report = powerbi.embed(this.embeddedReport.nativeElement, config);
    report.off('loaded');
    report.on('loaded', () => {
      console.log('Loaded');
    });
    report.on('error', () => {
      console.log('Error');
    });
  }
}
